import React from 'react';
import useDfcSurface from '../../../../hooks/useDfcSurface';
import useFitnessVillageCopy from '../../../../hooks/useFitnessVillageCopy';
import ringLight from '../../../../assets/dfc-village/loader/ring-light.png';
import ringDark from '../../../../assets/dfc-village/loader/ring-dark.png';
import numeralsLight from '../../../../assets/dfc-village/loader/numerals-light.png';
import numeralsDark from '../../../../assets/dfc-village/loader/numerals-dark.png';
import { LoaderScreen, Mark, Numerals, Ring, VisuallyHidden } from './style';

interface DfcPageLoaderProps {
  /** The whole viewport (before the company — and so the header — exists), or the page area */
  fullScreen?: boolean;
}

/**
 * The DFC site's loader: the 30x30 mark from DFC's own village artwork (DFC, 12/10: "it needs to
 * match the actual logos"), cut in two — the ring turns, the "30x30" lettering stays still — on
 * the page colour of the visitor's light / dark mode, with that mode's artwork. It needs nothing
 * from the company, so it can stand in for the whole app until the company is fetched, and
 * again in the page area while a page's code loads.
 */
const DfcPageLoader: React.FC<DfcPageLoaderProps> = ({ fullScreen = false }) => {
  const surface = useDfcSurface();
  const { label } = useFitnessVillageCopy().loader;

  return (
    <LoaderScreen
      surface={surface}
      fullScreen={fullScreen}
      role="status"
      aria-live="polite"
      data-testid="dfc-page-loader"
    >
      <Mark aria-hidden="true">
        <Ring src={surface.dark ? ringDark : ringLight} alt="" />
        <Numerals src={surface.dark ? numeralsDark : numeralsLight} alt="" />
      </Mark>
      <VisuallyHidden>{label}</VisuallyHidden>
    </LoaderScreen>
  );
};

export default DfcPageLoader;
